import * as errors    from '../util/errors';
import * as Resources from '../util/resources';


// -- Groups

export function readGroups(businessID) {
  return async function(dispatch) {
    try {
      await dispatch(Resources.readResources({
        url:                `${API_URL}/business/${businessID}/groups`,
        resourceType:       'groups',
        list:               businessID,
        mergeListIds:       false,
        requestKey:         `read-${businessID}`,
        showDefaultErrorUI: false,
        transformData:      ({ groups }) => groups.map(toResource)
      }));
    } catch (error) {
      dispatch(errors.showToastError(error));
      throw error;
    }
  };
}


function toResource(group) {
  return {
    ...group,
    id: group.name
  };
}
